<template>
  <ZubieDialog
    ref="dialog"
    ok-only
    title="Alert"
    :title-color="titleColor"
    @hide="
      $emit('update:visible', false);
      $emit('hide');
    "
  >
    {{ message }}
  </ZubieDialog>
</template>
<script>
export default {
  name: 'AlertDialog',
  props: {
    message: String,
    titleColor: String,
  },
};
</script>
